import PropTypes from 'prop-types';
import { renderingOnServer } from '../utils/env';

/*
 * Prop types that are common to ALL Rosetta top-level containers.
 * Specific top-level containers may override these.
 */
const commonPropTypes = {
  /*
   * Required
   */
  adsState: PropTypes.shape({
    ad_data: PropTypes.object.isRequired,
    adTargetingCompleted: PropTypes.bool.isRequired
  }).isRequired,
  alternate_urls: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  analytics: PropTypes.object.isRequired,
  api: PropTypes.shape({
    fetchStatus: PropTypes.string,
    hasErrors: PropTypes.bool,
    options: PropTypes.object,
    status: PropTypes.number
  }).isRequired,
  cookies: PropTypes.object,
  experiments: PropTypes.object,
  fetchFoundryResponse: PropTypes.func.isRequired,
  footerLinks: PropTypes.shape({
    company: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired,
    information: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired,
    editions: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired
  }).isRequired,
  isPreviewPage: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  meta_data: PropTypes.object.isRequired,
  modules: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  trendingItems: PropTypes.object.isRequired,
  shoppingNavigationItems: PropTypes.arrayOf(
    PropTypes.object
  ),
  recordSearchTerm: PropTypes.func.isRequired,
  edition_data: PropTypes.object.isRequired,
  wordpressApiHost: PropTypes.string.isRequired,

  /*
   * Optional
   */
  article: PropTypes.object,
  geolocation: PropTypes.string,
  newsletters: PropTypes.arrayOf(PropTypes.object),
  schema: PropTypes.string,
  product: PropTypes.object,
  productList: PropTypes.object,

  /*
   * Edge case: server-side only
   */
  guessedBreakpoint: renderingOnServer()
    ? PropTypes.string.isRequired
    : PropTypes.string
};

export default commonPropTypes;
